<template>
  <!-- マイページ -->
  <div class="mypage">
    <header class="header">
      <div class="account_name">
        <p>アカウント名： {{ userInfoStore.userDetail.name || guest }}様</p>
      </div>
      <img inline src="../assets/mypage-header.svg" />
    </header>
    <div class="mypage__list">
      <div class="list__title">
        <p class="LinkList__Text">アカウント情報</p>
      </div>
      <div
        v-for="(item, index) in filterAccountItemList()"
        :key="index"
        @click="push(item.page)"
        class="list__item"
      >
        <p>{{ item.name }}</p>
        <img class="detail_icon" src="../assets/detail.svg" align="right" />
      </div>
    </div>
    <div class="mypage__list">
      <div class="list__title">
        <p class="LinkList__Text">その他</p>
      </div>
      <div
        v-for="(item, index) in filterOtherItemList()"
        :key="index"
        @click="push(item.page)"
        class="list__item"
      >
        <p>{{ item.name }}</p>
        <img class="detail_icon" src="../assets/detail.svg" align="right" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { UNUSER, USER } from "../consts/common";
import { UserInfoStore } from "../store/UserInfoStore";
import { onBeforeMount, ref } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const userInfoStore = UserInfoStore();
document.title = "マイページ";
const guest = "ゲスト";
const name = ref("");

// const isUser = ref(0);

onBeforeMount(async () => {
  // トークンがあればアカウント登録済み
  // if (omistore.userDetail.user_state == USER) {
  //   isUser.value = 1;
  // }
  if (!userInfoStore.userDetail.id) {
    await userInfoStore.getUserDetail().then(() => {
      name.value = userInfoStore.userDetail.name;
      return;
    });
  } else if (!userInfoStore.bankInfo.id) {
    await userInfoStore.getBankInfo();
  }
  if (userInfoStore.addressInfo.id < 0) {
    await userInfoStore.getAddressInfo();
  }
  name.value = userInfoStore.userDetail.name;
});

// ページ遷移
function push(page: string) {
  if (page == "/policy") {
    window.open("https://fisminc.com/privacy-policy/");
  } else {
    router.push(page);
  }
}
// ユーザーとゲストで出すメニューをフィルターかける
//  どちらでも出す2
function filterAccountItemList() {
  return accountItemList().filter(
    (v) => v.isUser == userInfoStore.userDetail.user_state
  );
}

// ユーザーとゲストで出すメニューをフィルターかける
// どちらでも出す2
function filterOtherItemList() {
  return otherItemList.filter(
    (v) => v.isUser == userInfoStore.userDetail.user_state || v.isUser == 2
  );
}

function accountItemList() {
  return [
    { name: "新規登録", page: "/sign-up", isUser: UNUSER },
    { name: "プロフィール", page: "/account-detail", isUser: USER },
    { name: "SNSアカウント登録", page: "/sns-accounts", isUser: USER },
    {
      name: "振込先銀行口座情報",
      page: userInfoStore.bankInfo.id ? "/bank-detail" : "/bank",
      isUser: USER,
    },
    {
      name: "配送先住所情報",
      page:  userInfoStore.addressInfo.id > 0 ? "/address-detail" : "/address",
      isUser: USER,
    },
    { name: "三条書面一覧", page: "/documents", isUser: USER },
    { name: "支払い通知書一覧", page: "/user-payment-transfers", isUser: USER },
  ];
}

const otherItemList = [
  // TODO 内容確認中のため一旦非表示
  // { name: "FAQ・お問い合わせ", page: "/faq", isUser: 2 },
  { name: "利用規約", page: "/terms-of-use", isUser: 2 },
  { name: "プライバシーポリシー", page: "/policy", isUser: 2 },
  { name: "退会", page: "/withdrawal", isUser: USER },
];
// }
// })
</script>

<style scoped lang="scss">
@import "../assets/style/_variables.scss";
@import "../assets/style/_mixin.scss";
.mypage {
  overflow-y: auto;
  width: 100%;
  max-width: 480px;
  height: 100%;
  background: #eeeeee;
}
.mypage::-webkit-scrollbar {
  display: none;
}
.header {
  height: 110px;
  background: $OMOT_COLOR;
  width: 100%;
  position: sticky;
  top: 0;
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  p {
    font-style: normal;
    font-weight: 600;
    font-size: $FONT_SIZE_L;
    line-height: 150%;
    color: $white;
  }
}
.list__title {
  padding-left: 23px;
}

.mypage__list {
  width: 100%;
}
.list__item {
  @include menu-list-item();
}
.account_name {
  position: absolute;
  min-height: 32px;
  max-height: 100px;
  left: 20px;
  bottom: 0;
  word-break: break-all;
  overflow-y: auto;
}
</style>
